Vue.component("chat-main", {
	props: ["options", "labellang"],
	template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceUp" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">' +
		'<div id="content-chat" class="chat-main no-gutters" :class="{ \'escalation\': hasEscalation, \'withWidget\': isPanelWidgetOpen, }" >' +
		'<button v-if="hasOldMessages" class="load-old-message text-center" @click="loadOldMessages()">{{ this.labellang.old_message }}</button>' +
		'<transition-group name="slideLeft" :duration="700" tag="ul" class="list-message" :class="{ \'space-old-message\': hasOldMessages }" v-bind:css="options.internal.isAnimationCompatibility">' +
		'<li v-for="(item,index) in listMsg" v-bind:key="index" v-bind:class="[item.from, item.type]" class="offset-top-10">' +
		'<div v-if="item.type == \'nodo\'"><nodo-menu ref="nodoMenu"  :options="options" :currentnodo="item"></nodo-menu></div>' +
                '<div v-if="item.type == \'buttons\'"><nodo-buttons ref="nodoButtons"  :options="options" :labellang="labellang" :currentnodo="item"></nodo-buttons></div>' +
		'<div v-else-if="item.type == \'media\' "><nodo-multimedia ref="nodoMultimedia" :currentmedia="item"></nodo-multimedia></div>' +
		'<div v-else-if="item.type == \'map\'"><map-item ref="mapItem"  :options="options" :currentnodo="item"></map-item></div>' +
		'<div v-else-if="item.type == \'onlyText\'">' +
		'<div v-if="item.externalAgentName" v-bind:style="item.bubbleStyle"class="bubble bubble-agent row col-xs-11" ><div class="col-xs-3 text-center"> <img :src="getImgAgent(item.agentType)" class="img-agent" :class="setClassAgent(item.agentType)" onerror="svgOnError()"><span v-if="timeShow" class="time">{{ item.currentTime }}</span></div><div class="col-xs-9 no-gutters"><p class="show-name">{{ item.externalAgentName }}</p><div class="msg-text" v-html="item.msg.text"></div></div></div>' +
		'<div v-else-if="item.from == \'agent\'" class="bubble bubble-agent row col-xs-11" ><div class="col-xs-3 text-center"> <img :src="getImgAgent(item.agentType)" class="img-agent" :class="setClassAgent(item.agentType)" onerror="svgOnError()"><span v-if="timeShow" class="time">{{ item.currentTime }}</span></div><div class="col-xs-9 no-gutters"><div class="msg-text" v-html="item.msg.text"></div><p class="name">{{ item.name }}</p></div></div>' +
		'<div v-else-if="item.isLinkFromCustomer" class="bubble bubble-customer col-xs-11 row" ><div class="col-xs-9 no-gutters"><div class="msg-text" v-html="item.msg.text"></div><p class="name">{{ item.name }}</p></div><div class="col-xs-3 text-center"><img v-if="showImgCustomer" :src="imgCustomer" class="img-customer"  onerror="svgOnError()"><span v-if="timeShow" class="time">{{ item.currentTime }}</span></div></div>' +
		'<div v-else-if="item.from == \'customer\'" class="bubble bubble-customer col-xs-11 row" ><div class="col-xs-9 no-gutters"><div class="msg-text" v-text="item.msg.text"></div><p class="name">{{ item.name }}</p></div><div class="col-xs-3 text-center"><img v-if="showImgCustomer" :src="imgCustomer" class="img-customer"  onerror="svgOnError()"><span v-if="timeShow" class="time">{{ item.currentTime }}</span></div></div>' +
		'<div v-else-if="item.from == \'system\' || item.from == \'event\'" class="bubble bubble-system col-xs-10 col-xs-offset-1 row"><div class="col-xs-12"><div class="msg-text" v-html="item.msg"></div><span v-if="timeShow" class="time pull-right">{{ item.currentTime }}</span></div></div>' +
		'<div v-else-if="item.contentType == \'BLOB\'" class="bubble bubble-incomming col-xs-10 col-xs-offset-1 row" ><div class="col-xs-12"><a :href="item.link" :download="item.fileName" target="_blank"><i v-if="item.incommingFormat == \'document\'" class="material-icons pull-left">&#xE226;</i><i v-else-if="item.incommingFormat == \'link\'" class="material-icons pull-left">&#xE157;</i><div class="msg-text" v-html="item.msg"></div></a><span v-if="timeShow" class="time pull-right">{{ item.currentTime }}</span></div></div>' +
		'<div v-else-if="item.from == \'incomming\'" class="bubble bubble-incomming col-xs-10 col-xs-offset-1 row" ><div class="col-xs-12"><a :href="item.link" target="_blank"><i v-if="item.incommingFormat == \'document\'" class="material-icons pull-left">&#xE226;</i><i v-else-if="item.incommingFormat == \'link\'" class="material-icons pull-left">&#xE157;</i><div class="msg-text" v-html="item.msg"></div></a><span v-if="timeShow" class="time pull-right">{{ item.currentTime }}</span></div></div>' +
		"<div v-else></div>" +
		"</div>" +
		"<div v-else></div>" +
		'<button v-bind:class="{\'last-chat-element\' : index === (listMsg.length-1)}"  id="convyBackButton" v-if="showBackButtonChat" class="back-convy-message text-center" @click="backConvyMenu()" rel="tooltip" data-placement="right" :title="text.tooltipBackButton"><i class="convy-back-icon material-icons">replay</i></button>' +
                '<button v-bind:class="{\'last-chat-element\' : index === (listMsg.length-1)}"  id="convySubmitButton" v-if="showSubmitButton" :disabled="false" class="submit-convy-buttons text-center" @click="submitButtonsChoice()" rel="tooltip" data-placement="left" :title="text.tooltipSubmitButton"><i class="convy-submit-icon material-icons">done</i></button>' +
		'<div class="clearfix"></div></li>' +
		'<div class="clearfix"></div>' +
		"</transition-group>" +
		'<ul class="list-message" style="margin-top:25px"><li class="offset-top-10">'+
		'<div  v-if="restartBtn"  class="bubble bubble-system col-xs-10 col-xs-offset-1 row restart-convy-message-thankyou" >'+
		'	<div class="col-xs-12">'+
		'		<div class="msg-text text-center">{{text.thankyouMessage}}</div>' +
		'		<div  @click="openReserveEmail" v-if="allowEmailReservation" class="system-message-email-reservation msg-text text-center" style="padding-top:5px"><span><i style="font-size:16px; position:absolute; margin-left: -3px"class="material-icons">&#xE0BE;</i></span> <span style="margin-left: 10px;">{{text.email}}</span></div>'+
		'	</div>'+
		'	<button   id="convyRestartButton" v-if="restartBtn" class="back-convy-message text-center restart-convy-message" @click="restartConvy()"  >{{text.tooltipRestartButton}}</button>'+
		'</div>'+
		'</li></ul>'+
		"</div>" +
		"</transition>",

	data: function () {
		return {
			typeMessage: "",
			listMsg: [],
			repositoryItems: [],
			isActive: false,
			isHistory: false,
			hasOldMessages: false,
			showBackButtonChat: false,
                        showSubmitButton: false,
			countBackTargetFromConvy: null,
			agentName: null,
			tmp: new Array(),
			from: 0,
			to: 0,
			timeShow: true,
			hasEscalation: false,
			showImgCustomer: true,
			isComposing: {
				agent: false,
				customer: false
			},
			imgCustomer: this.options.imgCustomer,
			imgFailCustomer: this.options.imgFailCustomer,
			imgFailAgent: this.options.imgFailAgent,
			isPanelWidgetOpen: false,
			isMsgPw: false,
			perfect: null,
			text:{
				tooltipSubmitButton: this.labellang.tooltipSubmitButton,
				tooltipBackButton:this.labellang.tooltipBackButton,
				tooltipRestartButton:this.labellang.tooltipRestartButton,
				thankyouMessage:this.labellang.restart,
				email: this.labellang.emailToReserveTooltip
			},
			restartBtn: false,
			isFlowEnded:true,
			allowEmailReservation: this.options.configuration.allowEmailReservation
		};
	},
	watch: {
		restartBtn: function(val) {
			if(val){
				bus.$emit('hideRestartButton', true);
			}else{
				bus.$emit('hideRestartButton', false);
			}
		}
	},
	mounted: function () {

		// TODO Check History
		var that = this;

		this.$parent.$on('onDisableFooter', function(boolean) {
			//nello stesso momento in cui controllo il restart faccio il check sul pulsante della mail
			that.allowEmailReservation = that.options.configuration.allowEmailReservation;
			//il pulsante di restart funziona sempre, anche con agente normale
            that.restartBtn = boolean && that.isFlowEnded;
            if(that.restartBtn){
				setTimeout(function () {
					$('#chat-footer').hide();
				}, 1500);
				window.localStorage.removeItem(that.options.internal.cookie.options.name);
			}
		});

		this.$parent.$on("onShowChat", function (val) {
			that.contentShow(val);
		});
		this.$parent.$on("onSystemMsg", function (msg) {
			that.setSystemMsg(msg);
		});
		bus.$on("newMessage", function (msg) {
		  if(msg && msg.skipSendMessage){
        that.setMessage(msg, msg.skipSendMessage);
      }else{
        that.setMessage(msg, false);
      }
		});

        bus.$on('changeCloseSession', function(val) {
            that.isFlowEnded = val;
        });

		bus.$on('showBackButton', function (val) {
			that.showBackButtonChat = val;
		});

		bus.$on('showSubmitButton', function (val) {
		  if(val){
                    that.callTooltip();
                  }else{
		    that.hideTooltip();
                  }
		  that.showSubmitButton = val;
    });

		this.$parent.$on("newMessageLS", function (msg) {
			that.setMessageLS(msg);
			});
		this.$parent.$on("onMsgReceived", function (msg) {
			bus.$emit("log-event", { level: "INFO", message: "ChatMain.js - Recevied onMsgReceived with data " + JSON.stringify(msg) });
			var jsonArray = that.parseJsonsInString(msg);
			jsonArray.forEach(function (json) {
				setTimeout(function () {
					bus.$emit("log-event", { level: "INFO", message: "ChatMain.js - Handling message: " + JSON.stringify(json) });
					that.setMessageReceive(JSON.stringify(json));
				}, 1000);
			});
		});
		this.$parent.$on("onHistoryReceived", function (msg) {
			bus.$emit("log-event", { level: "INFO", message: "ChatMain.js - Handling history: " + JSON.stringify(msg) });
			that.setHistoryReceive(msg);
		});
		this.$parent.$on("onCloseChat", function (e) {
			that.closeChat(e);
		});
		this.$parent.$on("onEscalation", function (val) {
			that.setEscalation(val);
		});
		bus.$on("onEscalation", function (val) {
			that.setEscalation(val);
		});
		bus.$on("onUpdateScroll", function (val) {
			that.updateScroll();
		});
        bus.$on("expandChat", function (val) {
            //that.updateScroll();
            that.updateCarousel();
        });
		this.$parent.$on("onTrasfering", function (msg) {
			that.setSystemMsg(msg);
		});
		this.$parent.$on("onTrasferEnd", function (msg) {
			that.setSystemMsg(msg);
		});
		this.$parent.$on("onPause", function (msg) {
			that.setSystemMsg(msg);
		});
		this.$parent.$on("onResume", function (msg) {
			that.setSystemMsg(msg);
		});
		this.$parent.$on("onDocumentIncomming", function (dataDoc, dataName) {
			var incommingFormat = "document";
			that.setIncommingLinkDocument(dataDoc, incommingFormat, dataName);
		});
		this.$parent.$on("onLinkIncomming", function (dataDoc) {
			var incommingFormat = "link";
			that.setIncommingLinkDocument(dataDoc, incommingFormat);
		});
		this.$parent.$on("onDocumentSent", function (dataDoc, dataName) {
			var incommingFormat = "document";
			that.setSentLinkDocument(dataDoc, incommingFormat, dataName);
		});

		this.$parent.$on("onClassAllWidget", function () {
			that.removeWidgetPanel();
		});

		bus.$on("onCloseWidget", function (msg) {
			that.closeWidget(msg);
		});

		bus.$on("onKeyReplace", function (key) {
			that.setMessageReplace(key);
		});
		bus.$on("clearMessages", function() {
			that.restartConvy();
		});
		this.$parent.$on('clearLastMenu', function () {
			that.removeButtonNodeMenu();
			that.removeWidgetPanel();
			that.removeBackButton();
		});
	},
	filters: {
		trim: function (value) {
			return value.trim();
		}
	},
	methods: {

		openReserveEmail: function() {
			bus.$emit("onReserveEmail", true);
		},

		contentShow: function (val) {


			this.isActive = val;
			var that = this;
			setTimeout(function(){
				try {
				that.perfect = new PerfectScrollbar(".chat-main");
				} catch (e) {}
			 }, 100);


		},
		callTooltip:function(){
			Vue.nextTick(function () {
				$('[rel="tooltip"]').tooltip();
			})
		},
		hideTooltip:function(){
			$('[rel="tooltip"]').tooltip("hide");
		},
		svgOnError: function () {
			console.log("svgError");
		},
		getImgAgent: function (val) {
			if (val == "virtual") {
				return this.options.imgVirtualAgent;
			} else {
				return this.options.imgAgent;
			}
		},
		setClassAgent: function (val) {
			return val;
		},

		updateCarousel: function() {
			if(this.$refs.nodoMenu && this.$refs.nodoMenu[0] && this.$refs.nodoMenu[0].swiperTmp){
				this.$refs.nodoMenu[0].swiperTmp.update();
			}
		},
		updateScroll: function () {

            var that = this;
            this.callTooltip();

            var el = document.getElementById("content-chat");
            if (el) {
                el.scrollTop = el.scrollHeight;
            }
            if (this.perfect)
                this.perfect.destroy();
            //this.perfect.update();
            try {
                this.perfect = new PerfectScrollbar(".chat-main");
            }catch (e) {
            }

		},
		isString: function (val) {
			return (
				typeof val === "string" ||
				(!!val &&
					typeof val === "object" &&
					Object.prototype.toString.call(val) === "[object String]")
			);
		},
		isObject: function (item) {
			return typeof item === "object" && !Array.isArray(item) && item !== null;
		},

		setHistoryWithPagination: function (dataMsg) {
			var that = this;
			if (dataMsg.attributes && dataMsg.attributes.type=="FORM")
				return;
			this.tmp.push(dataMsg);
			this.from = Math.max(this.tmp.length - this.limitHistoryMsg(), 0);
			this.to = this.tmp.length;

			setTimeout(function () {
				that.listMsg = that.tmp.slice(that.from, that.to);
				setTimeout(function () {
					if (that.listMsg.length < that.tmp.length) {
						that.hasOldMessages = true;
					}
				}, 300);
				setTimeout(function () {
					that.updateScroll();
				}, 300);
			}, 1200);

		},
		checkHistoryTypeContent: function (tempMsg, currentContent, lastItem) {
      var that = this;
      // check type content message
      var isMedia = currentContent.hasOwnProperty("media") && currentContent.media;
      var isNodo = currentContent.hasOwnProperty("options") && currentContent.options;
      var iskeyboard = currentContent.hasOwnProperty("keyboard") && currentContent.keyboard.type != "text_input" && currentContent.keyboard.type != "text_input_disabled" && currentContent.keyboard.type != "custom";
      var isButtonsFromVA = currentContent.type === 'buttons';
      if(isButtonsFromVA){
        tempMsg.backTargets = currentContent.backTargets;
        tempMsg.attributes = currentContent.attributes;
        tempMsg.node_type = 'buttons';
      }
      var isContentFromVa = currentContent.hasOwnProperty('fullResponse');
      var isButtonsNode = tempMsg.node_type === 'buttons';

      // check type Message
      var currentTime = this.getTimer(tempMsg.timestamp);
      var whoName = null;
      var currentSenderInfo = tempMsg.senderInfo;
      var currentMsgType = tempMsg.type;
      var agentType = "";
      var agentName = "";
      var isFrom = "";
      var currentUrl = null;
      var dataType = "onlyText";
      var currentIncommingFormat = null;
      var lastItem = lastItem;
      // controllo se ho le info del sender
      if (currentSenderInfo) {
        if (currentSenderInfo.isVirtualAgent == "true") {
          agentType = "virtual";
          agentName = currentSenderInfo.agentDisplayName
        }
      } else {
        agentType = "real";
        agentName = "Agent"
      }

      // controllo quali tipo di messaggio ho
      //nel caso della form sollevo l'evento chatNodeFormEnable
      if (lastItem && tempMsg && tempMsg.type == "chat" && tempMsg.attributes && tempMsg.attributes.type == "FORM") {
        this.$parent.$emit("chatNodeFormEnable", tempMsg.attributes);
      }
      //Questo è il caso della form che mi arriva da WCS
      else if (lastItem && tempMsg && tempMsg.type == "chat" && currentContent.attributes && currentContent.attributes.type == "FORM") {
        this.$parent.$emit("chatNodeFormEnable", currentContent.attributes);
      }
      if (isNodo && lastItem) {
        dataType = "nodo"
      } else if (isButtonsNode && lastItem) {
        dataType = "buttons";
        currentContent = tempMsg;
      } else if (isButtonsNode && !lastItem){
        //se il nodo buttons è stato già navigato lo tratto come se fosse un solo testo cosi non viene mostrato i bottoni
        dataType = "onlyText";
        currentContent = {
          text: tempMsg.attributes.question
        }
      }else {
        dataType = "onlyText"
      }
			if (isMedia) { // ATTENZIONE controllare se è media dopo il nodo perchè media al suo interno potrebbe avere opzioni
				dataType = "media"
			}


      if(isContentFromVa){
        tempMsg.node_type = isButtonsNode ? 'buttons' : currentContent.type;
      }
			//questo perche aggiungo node type alla history sul bridge perche il campo type esiste gia
			var tmp = {};
			if (tempMsg.hasOwnProperty('node_type')) {
				tmp = {
					type: tempMsg.node_type
				};
			}
			if(isContentFromVa){
        tempMsg.backTargets = currentContent.backTargets;
      }
			if (tempMsg.hasOwnProperty('backTargets')) {
				this.countBackTargetFromConvy = tempMsg.backTargets;
			}
			var nodeTypeCheck = this.checkCurrentNodeType(tmp, tempMsg);
			this.checkBackButtonVisibility(nodeTypeCheck, lastItem);

			if (this.isMsgPw) {
				currentContent.text = appUnyco.$refs.panelKeyReplace.convertMsg(currentContent.text);
				this.isMsgPw = false;
				currentContent.isLinkFromCustomer = true;
			}

			if(tempMsg.who == "customer"){
			  currentContent.isLinkFromCustomer = true;
      }

			if (iskeyboard) {
				dataType = "onlyText"
				if (currentContent.keyboard.type == "password") {
					this.isMsgPw = true;
				}
			}
			// controllo chi mi ha inviato il il messaggio se customer setto You altrimenti è un agente;
			if (tempMsg.who) {
				isFrom = tempMsg.who;
				whoName = tempMsg.who;
			};

			// se è customer porto l'agente a null
			if (tempMsg.who == "customer") {
				agentType = null;
			} else if (tempMsg.who == "event") {
				currentContent = this.labellang[tempMsg.content] || tempMsg.content;
			}
			// Controllo se ho dei documentSharing or linkSharing
			if (currentMsgType == "documentSharing") {
				currentIncommingFormat = "document";
				isFrom = "incomming";
				currentUrl = currentContent.text; // lo imposto come Url
				currentContent = this.labellang.incomingDoc; // imposto il messaggio con la propria label
			}
			if (currentMsgType == "linkSharing") {
				currentIncommingFormat = "link";
				isFrom = "incomming";
				currentUrl = currentContent.text;
				currentContent = this.labellang.incomingLink;
			}
			// controllo documenti in uscita
			if (currentMsgType == "customerDocumentSharing" || tmp.type == "share_document") {
				currentIncommingFormat = "document";
				isFrom = "incomming";
				currentContent = this.labellang.shareDocDone; // imposto il messaggio con la propria label
			}
			//ho messo fuori questo cosi i link che arrivano dall'agente diventano cliccabili
      			if (this.hasLink(currentContent.text)) { // se il customer invia un link lo converto
        			currentContent.text = this.convertLink(currentContent.text, tempMsg.who !== "customer");
        			currentContent.isLinkFromCustomer = true;
     			}

			try {
				if (currentContent.text.indexOf("Lat:") !== -1 && currentContent.text.indexOf("Long:")) {
					dataType = "map";
				}
			} catch (e) {

			}

			// Definisco il mio modello di dati
			var dataMsg = {
				msg: currentContent,
				currentTime: currentTime,
				name: whoName,
				link: currentUrl,
				from: isFrom,
				type: dataType,
				agentType: agentType,
				incommingFormat: currentIncommingFormat,
				attributes: tempMsg.attributes || currentContent.attributes
			};
			if (tempMsg.contentType == 'BLOB' && tempMsg.fileName) {
				dataMsg.fileName = tempMsg.fileName;
				dataMsg.contentType = 'BLOB';
			};
			if(currentContent.isLinkFromCustomer){
				dataMsg.isLinkFromCustomer = true;
			}
			if (tempMsg.senderInfo && tempMsg.senderInfo.externalAgentName) {
				dataMsg.externalAgentName = tempMsg.senderInfo.externalAgentName;
				if (!this.options.internal.agentBubbleColoursMap[dataMsg.externalAgentName]) {
					this.options.internal.agentBubbleColoursMap[dataMsg.externalAgentName] = this.options.internal.agentBubbleColours[this.options.internal.currentIndexColour];
					if (this.options.internal.currentIndexColour == this.options.internal.agentBubbleColours.length - 1) {
						this.options.internal.currentIndexColour = 0;
					} else {
						this.options.internal.currentIndexColour++;
					}
				}
				dataMsg.bubbleStyle = "background: " + this.options.internal.agentBubbleColoursMap[dataMsg.externalAgentName];
			};


			if (currentMsgType == "documentSharing" || currentMsgType == "linkSharing") {
				var repositoryItem = {
					tpl: currentIncommingFormat,
					url: currentUrl,
					source: 'inbound',
					time: currentTime
				}
				if (tempMsg.fileName) {
					repositoryItem.name = fileName;
				}
				else {
					if (currentIncommingFormat == 'link') {
						repositoryItem.name = currentUrl.slice(0, 22);
						this.repositoryItems.push(repositoryItem);
						bus.$emit('addRepoItem', this.repositoryItems);
					}
					if (currentIncommingFormat == 'document') {
						var xs = this.$parent.getUrlParam(currentUrl);
						for (var key in xs) {
							if (key == "filename") {
								repositoryItem.name = xs[key];
							}
						}
						this.repositoryItems.push(repositoryItem);
						bus.$emit('addRepoItem', this.repositoryItems);
					}
				}
			}

			if (currentMsgType == "customerDocumentSharing") {
				var repositoryItem = {
					tpl: currentIncommingFormat,
					url: currentUrl,
					source: 'outbound',
					time: currentTime
				}
				if (tempMsg.fileName) {
					repositoryItem.name = fileName;
				}
				else {

					if (currentIncommingFormat == 'document') {
						repositoryItem.name = tempMsg.content;
						this.repositoryItems.push(repositoryItem);
						bus.$emit('addRepoItem', this.repositoryItems);
					}
				}
			}
			// Controllo se è l'ultimo elemento della lista
			if (lastItem) {
				// Se è na keybord apro il pannello Keyboard;
				if (iskeyboard) {
					setTimeout(function () {
						that.openWidgetPanel(currentContent.keyboard);
					}, 1100);
				}
				if (currentContent.hasOwnProperty("keyboard") && currentContent.keyboard.type == "text_input_disabled") {
					bus.$emit("onInputMsgDisabled", true);
				}
				lastItem = false;
			}

			this.setHistoryWithPagination(dataMsg);

		},
		setHistoryReceive: function (msg) {
		  console.log(msg);
			var lastItem = false;
			var isMsgStringObject = null;
			var currentContent = null
			var len = msg.length;
			// Ciclo tuttti i messaggi

			for (i = 0; i < len; i++) {
				tempMsg = msg[i];
				currentContent = msg[i].content;
				// 1 controllo se il content è una stringa
				// Provo a parsarlo come JSON
				try {
					JSON.parse(currentContent);
					isMsgStringObject = true;
				} catch (e) {
					isMsgStringObject = false;
				}
				// Controllo se è l'ultimo elemento.
				if (i == len - 1) {
					lastItem = true;
				}
				// Se è un oggetto verifico quali tipi di oggetto mi arrivano
				if (isMsgStringObject) {
					if (isNaN(currentContent)) {// se non un numero riporto il messaggio a non string object
						currentContent = JSON.parse(currentContent);
					} else {
						currentContent = {
							text: currentContent
						};
						isMsgStringObject = false;
					}
				}
				else if (typeof currentContent != "object") {
					// se il messaggio non è un oggetto gli metto un msg:object
					// test message from wcs

					currentContent = {
						text: currentContent
					};
				}
				this.checkHistoryTypeContent(tempMsg, currentContent, lastItem);
			}
		},
		setSystemMsg: function (msg) {
			var that = this;
			var dataMsg = {
				msg: msg,
				currentTime: this.getTimer(),
				from: "system",
				type: "onlyText",
				name: this.options.internal.agentDisplayName != "" ?
					this.options.internal.agentDisplayName : "Agent"
			};

			this.listMsg.push(dataMsg);

			setTimeout(function () {
				that.updateScroll();
			}, 300);
		},
		setIncommingLinkDocument: function (url, incommingFormat, fileName) {

			var that = this;
			var msg = "";

			if (incommingFormat == "document") {
				msg = this.labellang.incomingDoc;
			} else {
				msg = this.labellang.incomingLink;
			}

			var dataMsg = {
				msg: msg,
				currentTime: this.getTimer(),
				link: url,
				from: "incomming",
				type: "onlyText",
				incommingFormat: incommingFormat,
				name: this.options.internal.agentDisplayName != "" ?
					this.options.internal.agentDisplayName : "Agent"
			};
			if (fileName) {
				dataMsg.fileName = fileName;
				dataMsg.contentType = 'BLOB'
			}
			this.listMsg.push(dataMsg);

			var repositoryItem = {
				tpl: incommingFormat,
				url: url,
				source: 'inbound',
				time: this.getTimer()
			}
			if (fileName) {
				repositoryItem.name = fileName;
			}
			else {
				if(incommingFormat == 'link') {
				repositoryItem.name = url.slice(0,22);
				}
				if(incommingFormat == 'document') {
					var xs = this.$parent.getUrlParam(url);
					for (var key in xs) {
						if (key == "filename") {
							repositoryItem.name = xs[key];
						}
					}
				}
			}
			this.repositoryItems.push(repositoryItem);
			bus.$emit('addRepoItem',this.repositoryItems);

			setTimeout(function () {
				that.updateScroll();
			}, 300);
		},
		setSentLinkDocument: function (url, incommingFormat, fileName) {

			var that = this;

			var repositoryItem = {
				tpl: incommingFormat,
				url: url,
				source: 'outbound',
				time: this.getTimer()
			}
			if (fileName) {
				repositoryItem.name = fileName;
			}
			else {
				if(incommingFormat == 'link') {
				repositoryItem.name = url.slice(0,22);
				}
				if(incommingFormat == 'document') {
					var xs = this.$parent.getUrlParam(url);
					for (var key in xs) {
						if (key == "filename") {
							repositoryItem.name = xs[key];
						}
					}
				}
			}
			this.repositoryItems.push(repositoryItem);
			bus.$emit('addRepoItem',this.repositoryItems);
			$('[rel="tooltip"]').tooltip("hide");
			this.removeWidgetPanel();

			setTimeout(function () {
				that.updateScroll();
			}, 300);
		},
		hasLink: function (msg) {
			if (!msg) return false;
			var link = new RegExp("(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$").test(msg);
			var email = new RegExp("[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$").test(msg);
			return link || email;
		},
		/**
		 * Il SessionHandler restituisce tre tipi di messaggi:
		 * * Stringa normale: "Ciao, come va"
		 * * JSON stringhificato: "{'text': 'Ciao, come va'}"
		 * * Concatenazione di JSON stringhificato con line break: "{'text': 'ciao'}\n{'text': 'come va?'}"
		 *
		 * Il primo try controlla il caso 2
		 * Il secondo try dentro il catch controlla il caso 3, pulendolo prima dai vari line break
		 * Il catch finale invece controlla il caso 1
		 *
		 * Restituisco sempre un'array contenente un json, in modo da invocare l'evento onReceivedMessage per ogni messaggio, abbiamo il caso segnalato
		 */
		parseJsonsInString: function (str) {
			var objectArray = [];

			try {
				var json = JSON.parse(str);
				objectArray.push(json);
			} catch (e) {
				try {
					//Questa riga serve a gestire i messaggi concatenati provenienti da Convy. NON va rimossa.
					//Se causa problemi sentire simone o teo (preferibilmente simone che teo non ha voglia)
					str = str.replace(/}\n{/ig, '}{');
					//str = str.replace(/(\r\n\t|\n|\r\t)/gm, "");
					var jsonArray = "[" + str.split("}{").join("},{") + "]";
					objectArray = JSON.parse(jsonArray);
				} catch (e) {
					var json = {
						"text": str
					};
					objectArray.push(json);
				}
			}

			return objectArray;
		},
		openWidgetPanel: function (keyboard) {
			var that = this;
			this.isPanelWidgetOpen = true;
			bus.$emit("onInputClean");
			bus.$emit("onInputMsgDisabled", true);

			switch (keyboard.type) {
				case "date":
					bus.$emit("onShowPanelCalendar", true); // mostra tastiera data
					bus.$emit("onCallTypeCalendar", keyboard);
					break;
				case "time":
					bus.$emit("onShowPanelCalendar", true);
					bus.$emit("onCallTypeCalendar", keyboard);
					break;
				case "datetime":
					bus.$emit("onShowPanelCalendar", true);
					bus.$emit("onCallTypeCalendar", keyboard);
					break;
				case "geolocation":
					bus.$emit("onShowPanelGeoLocation", true);
					break;
				case "survey_10_buttons":
					bus.$emit("onShowPanelSurvey", true);
					break;
				case "password":
					bus.$emit("onShowPanelKeyReplace", true);
					break;
				default:
					return false;
			}

			setTimeout(function () {
				that.updateScroll();
			}, 300);

		},
		removeWidgetPanel: function () {
			bus.$emit("onShowPanelCalendar", false);
			bus.$emit("onShowPanelGeoLocation", false);
			bus.$emit("onShowPanelKeyReplace", false);
			bus.$emit("onShowPanelSurvey", false);
			bus.$emit("onInputMsgDisabled", false);
			bus.$emit("onCloseWidgetForm", false);
			this.isPanelWidgetOpen = false;

		},
		closeWidget: function (msg) {
			this.isPanelWidgetOpen = false;
			this.setMessage(msg);

		},
		setMessageReceive: function (msg) {
			//tanto wcs non manda l'evento e quindi sarà sempre null.
			//se becco un nodo file di convy, le setto per quel nodo, fino al successivo
			if(!this.options.internal.isConvy) {
				this.options.internal.allowedExtensions = null;
			}
			this.isHistory = false;
			var that = this;
			var currentMsg = null;
			var agentType = this.options.agentType;
			var typeMsg = '';
			if (this.options.isVirtualAgent) {
				this.agentType = "virtual";
			} else {
				this.agentType = "real";
			}

			if (this.isString(msg)) {
				var isMsgStringObject = false;
				try {
					if (typeof JSON.parse(msg) === "object") {
						isMsgStringObject = true;
					}
				} catch (e) {
					isMsgStringObject = false;
				}
				if (isMsgStringObject) {
					msg = JSON.parse(msg);
				} else {
					msg = {
						text: msg
					};
				}
				currentMsg = msg;
			} else {
				currentMsg = msg; // message from BC
			}
			// var isPromptMessage = currentMsg.hasOwnProperty("text") && currentMsg.text.hasOwnProperty("type") && currentMsg.text.type === "cobrowsing-prompt";

			// if (!isPromptMessage) {
			bus.$emit("log-event", { level: "INFO", message: "ChatMain.js - Creating message node for " + JSON.stringify(currentMsg) });


			if (currentMsg.hasOwnProperty('backTargets')) {
				this.countBackTargetFromConvy = currentMsg.backTargets;
			}
			var iskeyboard = currentMsg.hasOwnProperty("keyboard") && currentMsg.keyboard.type !== "text_input" && currentMsg.keyboard.type !== "text_input_disabled" && currentMsg.keyboard.type !== "custom";
			var isMedia = currentMsg.hasOwnProperty("media");
			var isNodo = currentMsg.hasOwnProperty("options");
			var isButtons = currentMsg.type === "buttons";
			if (msg && msg.type == "form") {
				this.$parent.$emit("chatNodeFormEnable", msg.attributes);
			} else {
				bus.$emit("onCloseWidgetForm", true);
			}

			if (currentMsg.text) {
				if (this.hasLink(currentMsg.text)) {
					currentMsg.text = this.convertLink(currentMsg.text, true)
				}
			}
			if (isMedia) {
				dataType = "media"
			} else if (isNodo) {
                                dataType = "nodo"
        			$(".box-nodo-menu").remove();
      			} else if(isButtons) {
			        dataType = "buttons"
			} else {
				dataType = "onlyText"
			}
			if (iskeyboard) {
				dataType = "onlyText"

				setTimeout(function () {
					that.removeWidgetPanel();
					that.openWidgetPanel(currentMsg.keyboard);
				}, 1100);
			}

			if (currentMsg.hasOwnProperty("keyboard") && currentMsg.keyboard.type == "text_input_disabled") {
				bus.$emit("onInputMsgDisabled", true);
			} else {
				bus.$emit("onInputMsgDisabled", false);
			}

			var nodeTypeCheck = this.checkCurrentNodeType(currentMsg);
			this.checkBackButtonVisibility(nodeTypeCheck, true);

			var dataMsg = {
				msg: currentMsg,
				currentTime: this.getTimer(),
				from: "agent",
				type: dataType,
				name: this.options.internal.agentDisplayName != "" ? this.options.internal.agentDisplayName : "Agent",
				agentType: this.agentType,
				externalAgentName: (currentMsg.externalAgentName ? currentMsg.externalAgentName : null),
			};


			// } else {
			// 	bus.$emit("log-event", { level: "INFO", message: "ChatMain.js - Creating Cobrowsing prompt for " + JSON.stringify(currentMsg) });

			// 	dataType = 'cobrowsing-prompt';

			// 	var dataMsg = {
			// 		msg: currentMsg.text.promptData,
			// 		currentTime: this.getTimer(),
			// 		from: "agent",
			// 		type: dataType,
			// 		name: this.options.internal.agentDisplayName != "" ? this.options.internal.agentDisplayName : "Agent",
			// 		agentType: this.agentType,
			// 		externalAgentName: (currentMsg.externalAgentName ? currentMsg.externalAgentName : null),
			// 	};
			// }

			if (!this.options.internal.agentBubbleColoursMap[dataMsg.externalAgentName]) {
				this.options.internal.agentBubbleColoursMap[dataMsg.externalAgentName] = this.options.internal.agentBubbleColours[this.options.internal.currentIndexColour];
				if (this.options.internal.currentIndexColour == this.options.internal.agentBubbleColours.length - 1) {
					this.options.internal.currentIndexColour = 0;
				} else {
					this.options.internal.currentIndexColour++;
				}
			}

			dataMsg.bubbleStyle = "background: " + this.options.internal.agentBubbleColoursMap[dataMsg.externalAgentName];

			bus.$emit("log-event", { level: "INFO", message: "ChatMain.js - Message handling result: " + JSON.stringify(dataMsg) });

			if (this.listMsg.length <= 1) {
				// delay fist message for fix init interface
				setTimeout(function () {
					that.addMessageToLocalHistory(dataMsg);
					if (msg.type != "form") {
						that.listMsg.push(dataMsg);
					}
				}, 1000);
			} else {
				this.addMessageToLocalHistory(dataMsg);
				if (msg.type != "form") {
					this.listMsg.push(dataMsg);
				}
			}

			this.$parent.blinkMessageReceived();

			setTimeout(function () {
				that.updateScroll();
			}, 300);
		},
		addMessageToLocalHistory: function (dataMsg) {
			/*
			Questo metodo serve perchè dopo un refresh (con la possibilità di caricare vecchi messaggi)
			non mi salvo i messaggi che vengono scambiati dopo il refresh, quindi al ricalcolo dei mex
			vecchi non conto gli ultimi, quindi in tutti i punti li vado ad aggiungere. Potrei controllare
			se l'ultimo messaggio era un nodo o un media allora lo rimetto a onlytext cosi nel caso in
			cui clicco su carica vecchi messaggi non li rimostro
			 */
			var lastMsg = null;
			if(this.tmp && this.tmp.length > 0){
				lastMsg = this.tmp[this.tmp.length -1];
				/* controllo il tipo di nodo dell'ultimo messaggio */
				if(lastMsg && lastMsg.msg && (lastMsg.msg.hasOwnProperty("media") || lastMsg.msg.hasOwnProperty("options"))){
					/* il nodo multimedia deve essere sempre cliccabile, quindi non lo faccio diventare solo testo */
					if(lastMsg.msg.type != 'multimedia') {
						this.tmp[this.tmp.length - 1].type = 'onlyText';
					}
				}

			}
			this.tmp.push(dataMsg);
			this.to = this.tmp.length;
		},
    		convertLink: function (inputText, splitted) {
      		if (!inputText) return inputText;
      		var replacedText, replacePattern1, replacePattern2, replacePattern3;

      //Change email addresses to mailto:: links.
      replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
      if (replacePattern3.test(inputText)) {
        replacedText = inputText.replace(
          replacePattern3,
          '<a href="mailto:$1">$1</a>'
        );
				return replacedText;
      } else {
        if(!splitted){
          return this.sanitizeInput(inputText);
        }else{
          var splitText = inputText.split(" ");
          for(var i = 0; i < splitText.length; i ++ ){
            if(this.hasLink(splitText[i])){
              splitText[i] = this.sanitizeInput(splitText[i]);
            }
          }
        }
        return splitText.join(" ");
      }

    },
		containsEmail: function(value) {
			var re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
			return re.test(value);
		},
    sanitizeInput: function(msg) {
	    var replacedText;
      var replacePattern2 = /(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?/gim;
      //Spiegazione di questa riga: eravamo attaccavili da injection javascript del tipo  google.com/#"><svg/onload=alert(document.domain)//
      //perchè quella riga contiene un url che ha nell'ancora una injection javascript. La soluzione che ho pensato è encodare < e > in html in modo tale
      //da disattivare le possibili injection di nodi html.
      msg = msg.replace(/</g,"&#x3C;").replace(/>/g,"&#x3E;");
      //////

			if (this.containsEmail(msg)) {
				return msg;
			}
			//Dato che da qui ora ci passa tutto devo evitare di eseguire il pezzo successivo se non ci sono URL
			if (!this.hasLink(msg)) {
				return msg;
			}

      replacedText = msg.replace(
        replacePattern2,

        '<a href="http://$&" target="_blank">$&</a>'
      );
      //Spiegazione di questa porcheria:
      //la replace precedente serve a individuare degli url nella frase scritta dall'utente. Se per esempio trova www.google.it
      //fa la replace e ci scrive <a href="http://www.google.it" target="_blank">www.google.it</a>
      //se però viene nel messaggio viene trovato http://www.google.it
      //la replace genera questo tag a:
      //<a href="http://http://www.google.it" target="_blank">http://www.google.it</a>
      //che ovviamente non funziona.
      //Rimuovere il http:// dalla riga 924 risolve il problema, ma poi non funziona più il primo caso.
      //l'unica soluzione che mi è venuta in mente è quella di fare una seconda replace di sanificazione
      if (replacedText.indexOf('href="http://http') != -1) {
        replacedText = replacedText.replace('http://http', 'http');
      }

      return replacedText;
    },

		setMessageReplace: function (msgKey) {
			this.isPanelWidgetOpen = false;

			var that = this;
			var dataMsg = {
				msg: {
					text: msgKey
				},
				currentTime: this.getTimer(),
				from: "customer",
				type: "onlyText",
				name: "You",
				isLinkFromCustomer: true
			};

			this.listMsg.push(dataMsg);
			setTimeout(function () {
				that.updateScroll();
			}, 300);

		},
		setMessage: function (msg, skipSendMessage) {
		  	var attributes = {};
			var isLinkFromCustomer = false;
			if (!msg) return;
			bus.$emit("onInputMsgDisabled", false);
			this.removeButtonNodeMenu();

			var isMap = null;

			try {
				if (msg.indexOf("Lat:") !== -1) {
					isMap = true;
				}
			} catch (e) {
				isMap = false;
			}
			var isButtonsChoice = msg && msg.buttonsChoice;

			if (isMap) {
				currentType = "map"
			} else {
				currentType = "onlyText"
			}
      if(msg.from){
        if(msg.from === 'menu'){
          attributes.isLinkFromCustomer = true;
          isLinkFromCustomer = true;
          msg = msg.msg;
        }
        if(msg.from == 'buttons'){
          attributes.isLinkFromCustomer = true;
          isLinkFromCustomer = true;
        }
      }
			if(!skipSendMessage) {
				//TEO sta roba non si può fare, se invio il testo www.google.it me lo trasforma in html..
        //msg = this.sanitizeInput(msg); //per evitare injection se convy ritorna il testo
        this.options.internal.bridge.sendChatMessage(msg.replace(/</g,"&#x3C;").replace(/>/g,"&#x3E;"), attributes);
      }

			if(isButtonsChoice){
			  msg = msg.buttonsChoice.join(', ');
      			}
			if (this.hasLink(msg)) {
				msg = this.convertLink(msg);
				isLinkFromCustomer = true;
			}
			this.checkBackButtonVisibility(false, false);
			var that = this;
			var dataMsg = {
				msg: {
					text: msg
				},
				isLinkFromCustomer: isLinkFromCustomer,
				currentTime: this.getTimer(),
				from: "customer",
				type: currentType,
				name: "You"
			};

			this.addMessageToLocalHistory(dataMsg);
			this.listMsg.push(dataMsg);
		//	console.log(this.listMsg);
			setTimeout(function () {
				that.updateScroll();
			}, 300);
		},
		setMessageLS: function (msg) {
		//	console.log(msg);

			var isLinkFromCustomer = false;


		//	this.options.internal.bridge.sendChatMessage(msg);

			if (this.hasLink(msg)) {
				msg = this.convertLink(msg);
				isLinkFromCustomer = true;
			}

			if(msg.attributes && msg.attributes.isLinkFromCustomer){
			  isLinkFromCustomer = true;
      }

			var that = this;
			var dataMsg = {
				msg: {
					text: msg.text
				},
				isLinkFromCustomer: isLinkFromCustomer,
				currentTime: this.getTimer(),
				from: "customer",
				type: "onlyText",
				name: "You"
			};

			this.listMsg.push(dataMsg);
			$('[rel="tooltip"]').tooltip("hide");
			this.removeWidgetPanel();
			this.removeButtonNodeMenu();
			setTimeout(function () {
				that.updateScroll();
			}, 300);
		},
		getTimer: function (timestamp) {
			if (timestamp) {
				return this.$parent.getTimeFromTimestamp(timestamp); // TODO from timestamp
			} else {
				return this.$parent.getTime();
			}
		},
		isDefined: function (item) {
			return typeof item != typeof undefined && item != null;
		},
		limitHistoryMsg: function () {
			return this.options.internal.history.config.rangeMessageToLoad;
		},
		loadOldMessages: function () {
			var that = this;
			this.isHistory = true;
			this.from = this.from - this.limitHistoryMsg();
			if (this.from <= 0) {
				this.from = 0;
				this.hasOldMessages = false;
			}
			this.listMsg = this.tmp.slice(this.from, this.to);
			//supponiamo che il bottone di restart venga sempre e solo mostrato nel caso in cui la conversazione è terminata
			//i 300 millis sono necessari per dare il tempo alla history di caricarsi al suo interno e poter rimuovere
			//eventualmente tutti i bottoni che compaiono nei menu o nei menu caroselli
			setTimeout(function() {
				if (that.restartBtn) {
					that.removeButtonNodeMenu();
					that.removeWidgetPanel();
					$('#chat-footer').hide();
				}
			}, 300);

			// setTimeout(function() {
			//     that.updateScroll();
			// }, 300);
		},
    submitButtonsChoice: function () {
      if(this.$refs.nodoButtons && this.$refs.nodoButtons.length > 0) {
        this.$refs.nodoButtons[this.$refs.nodoButtons.length - 1].submitButtonsChoice();
      }
    },
		backConvyMenu: function () {
			var that = this;
			this.showBackButtonChat = false;
			var event = {
				eventName: this.options.ConvyEvent.SYSTEM_CONVY_EVENT_BACK,
				parameters: {
					messageLabel: this.labellang.convy_back_message
				},
				callback:function(response){
					if(response && response.attributes && response.attributes.backTargets){
						that.countBackTargetFromConvy = response.attributes.backTargets;
					}
				}
			};
			this.options.internal.bridge.sendChatEvent(event);
			var dataMsg = {
				msg: {
					text: this.labellang.convy_back_message
				},
				isLinkFromCustomer: false,
				currentTime: this.getTimer(),
				from: "customer",
				type: "onlyText",
				name: "You"
			};

			this.listMsg.push(dataMsg);
			//meno due perchè rimuovo il nodo corrente e quello prima, che eventualmente prima del check viene riaggiunto
			$('[rel="tooltip"]').tooltip("hide");
			this.removeWidgetPanel();
			this.removeButtonNodeMenu();
			setTimeout(function () {
				that.updateScroll();
			}, 300);
			//questo appende e invia il messaggio a Convy, io non devo farlo solo graficamente???
			/*var msg = 'Back';
			bus.$emit("newMessage", msg);*/
		},
		restartConvy: function() {
			if (this.options.internal.haveAlreadySessionActive) {
				//this.options.internal.bridge.closeSession();
				this.$parent.closeSession({
                    skipRefresh : true
                });
			}
      this.$parent.createSessionCookie(this.options.internal.cookie.props.cogitosearchstatus, this.options.PopoverStatus.DESTROYED);
      this.$parent.createSessionCookie(this.options.internal.cookie.props.cogitourlopen, "");
			this.$parent.restartChat();
			setTimeout(function(){
				this.listMsg = [];
				this.tmp = [];
				this.hasOldMessages = false;
				this.$parent.$emit('onDisableFooter', false);
				this.$parent.createSessionCookie(this.options.internal.cookie.props.popoverstatus, this.options.PopoverStatus.EXPANDED);
				this.$parent.askSession(this.options.internal.customerInfo, true);
                this.restartBtn = false;
			}.bind(this), 1500);


		},
		removeButtonNodeMenu: function () {
			var nodo = $(".box-nodo-menu");
			if (nodo.length) {
				$(".box-nodo-menu").remove();
			}
			nodo = $('.nodo-menu-slide');
			if(nodo.length){
				$(".nodo-menu-slide").remove();
			}
			this.showSubmitButton = false;
      this.hideTooltip();
		},
		removeBackButton: function() {
			bus.$emit('showBackButton', false);
		},
		closeChat: function (e) {
			var that = this;
			this.removeButtonNodeMenu();
			this.removeWidgetPanel();
			this.removeBackButton();
			switch (e.reason) {
				case "agent":
					if (!this.options.internal.isConvy) {
						var jsonArray = this.parseJsonsInString(this.labellang.bye);

						jsonArray.forEach(function (json) {
							//this.setMessageReceive(JSON.stringify(json));
						}.bind(this));
					}
					if (this.options.configuration.allowEmailReservation) {
						//bus.$emit("onReserveEmail", true);
					}
					//bus.$emit("onMsgClose", this.labellang.bye);

					this.updateScroll();
					this.options.internal.endChat = true;
					break;
				case "customer":
					//this.setMessage(this.labellang.bye);
					setTimeout(function () {
						$('#chat-footer').hide();
					}, 1500);
					break;
				default:
					break;
			}
			setTimeout(function () {
				that.updateScroll();
			}, 300);
		},
		setEscalation: function (val) {
			this.hasEscalation = val;
		},
		checkBackButtonVisibility: function(checkNodeObj, lastItem) {
			if(this.countBackTargetFromConvy && this.countBackTargetFromConvy > 0){
				if (typeof checkNodeObj === "object") {
					this.showBackButtonChat = (this.options.internal.isConvy || this.options.isVirtualAgent || this.options.isVirtualAgent == 'true') && lastItem &&
						(checkNodeObj.isFile || checkNodeObj.isSurvey || checkNodeObj.isSwitch || checkNodeObj.isQuestion || checkNodeObj.isButtons);
				} else {
					this.showBackButtonChat = false;
				}
			}else{
				this.showBackButtonChat = false;
			}
		},
		checkCurrentNodeType: function (currentMsg, historyMsg) {
			var checkObj = {};
			var checked = false;
			checkObj.isFile = false;
			if (currentMsg.hasOwnProperty("type") && currentMsg.type.toLowerCase() === 'file') {
				if(!this.options.internal.isConvy) {
					//in caso di f5 check se ultimo messaggio della history è un nodo file
					if(historyMsg && historyMsg.content){
						try{
							var parsedContent = JSON.parse(historyMsg.content);
							if(parsedContent.attributes && parsedContent.attributes.allowedExtension && parsedContent.attributes.allowedExtension.length > 0){
								var that = this;
								that.options.internal.allowedExtensions = parsedContent.attributes.allowedExtension;
							}
						}	catch(e){/*non mi interessa*/}
					}
					//messaggio ricevuto
					if(currentMsg.attributes && currentMsg.attributes.allowedExtension && currentMsg.attributes.allowedExtension.length > 0){
						this.options.internal.allowedExtensions = currentMsg.attributes.allowedExtension;
					}
				}
				checkObj.isFile = true;
				checked = true;
			}

            checkObj.isSurvey = false;
            if(currentMsg.hasOwnProperty("type") && currentMsg.type.toLowerCase() === 'survey'){
                checkObj.isSurvey = true;
				checked = true;
            }

            checkObj.isSwitch = false;
            if(currentMsg.hasOwnProperty("type") && (currentMsg.type.toLowerCase() === 'menu' || currentMsg.type.toLowerCase() === 'semantic' || currentMsg.type.toLowerCase() === 'switch')){
                checkObj.isSwitch = true;
				checked = true;
            }

            checkObj.isQuestion = false;
            if(currentMsg.hasOwnProperty("type") && currentMsg.type.toLowerCase() === 'question'){
                checkObj.isQuestion = true;
				checked = true;
			}
      checkObj.isButtons = false;
      if (currentMsg.hasOwnProperty("type") && currentMsg.type.toLowerCase() === 'buttons') {
        checkObj.isButtons = true;
        checked = true;
      }
			if (checked) {
				this.countShowBackButton++;
			}
			return checkObj;
		}
	}
});
